<template>
  <div class="page">
    <div class="roll_back_line flex justify-between">
      <div @click="goBack" class="inline-block flex w-1/3 justify-start items-center go_back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 18L8 12L14 6" stroke="#6c757d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h-full label_roll_back">
          Back
        </div>
      </div>
    </div>
    <div class="title_line flex items-center justify-between w-full px-16">
      <h1>Route Details</h1>
      <div class="route-action flex gap-10p">
        <div @click="shareRoute()" class="text-grey-dark hover:text-primary cursor-pointer" title="Share Route">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" size="20" height="20" width="20"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"></path></svg>
        </div>
        <div @click="rePlanRoute()" class="text-grey-dark hover:text-primary cursor-pointer" title="Re-plan Route">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" size="20" height="20" width="20"><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"></path></svg>
        </div>
        <div @click="printPage()" class="text-grey-dark hover:text-primary cursor-pointer" title="Print Preview">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" size="20" height="20" width="20"><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"></path></svg>
        </div>
        <div @click="deleteRoute()" class="text-grey-dark hover:text-red-600 cursor-pointer" title="Delete Route">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" size="20" height="20" width="20"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>
        </div>
      </div>
    </div>
    <div class="body" v-if="error_load">
      <div class="w-full error">
        Oooops! Something went wrong!
      </div>
    </div>
    <div class="body" v-if="!error_load && loaded_info">
      <div class="route_details px-16 py-5">
        <div class="text-left bordered rounded p-2" >
          <div class="title rounded bg-grey-lighter py-5 px-5">
            <h2 >Route details</h2>
          </div>
          <div class="info">
            <div class="info_group flex w-full py-4">
              <div class="name w-1/3">
                Company
              </div>
              <div class="value w-2/3 px-4">
                {{user_data.company_name}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Route ID
              </div>
              <div class="value w-2/3 px-4">
                {{$route.params.id}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Route name
              </div>
              <div class="value w-2/3 px-4">
                {{route_data.name}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Origin
              </div>
              <div class="value w-2/3 px-4">
                {{ originLabel }}
              </div>
            </div>
            <div
              class="info_group flex py-4"
              v-for="(section, index) in route_data.direction_data.routes[0].sections"
              :key="index"
            >
              <div class="name w-1/3">
                <span>{{ index +1 }} Destination</span>
              </div>
              <div class="value w-2/3 px-4 flex gap-20p">
                <span>
                  {{ section.arrival.place.postalCode }}, {{ section.arrival.place.address }}
                </span>

                <div v-if="sectionWaitDuration(section) > 0">
                  <span>
                    [ + {{ secondsToDhms(sectionWaitDuration(section)) }} wait ]
                  </span>
                </div>
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Submission date
              </div>
              <div class="value w-2/3 px-4">
                {{route_data.created_at | moment('DD-MM-YYYY')}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Start time
              </div>
              <div class="value w-2/3 px-4">
                {{getDateTime(route_data.direction_data.routes[0].sections[0].departure.time)}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                End time
              </div>
              <div class="value w-2/3 px-4">
                {{getDateTime(route_data.direction_data.routes[0].sections[route_data.direction_data.routes[0].sections.length-1].arrival.time)}}
              </div>
            </div>
            <div class="info_group flex py-4">
              <div class="name w-1/3">
                Duration
              </div>
              <div class="value w-2/3 px-4">
                {{ formatPlannedExpectedDuration() }}
              </div>
            </div>
            <div class="info_group flex py-4" v-if='route_data.route_options && route_data.route_options.vehicles_dimensions'>
              <div class="name w-1/3">
                Planned Dimension
              </div>
              <div class="value w-2/3 px-4">
                <div class='w_100'>
                  <span class="item">Height {{route_data.route_options.vehicles_dimensions.height.val || '-'}} m, </span>
                  <span class="item">Width {{route_data.route_options.vehicles_dimensions.width.val || '-'}} m, </span>
                  <span class="item">Length {{route_data.route_options.vehicles_dimensions.length.val || '-'}} m, </span>
                  <span class="item">Weight {{route_data.route_options.vehicles_dimensions.weight.val || '-'}} t</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vehicles_details px-16 py-5" v-if="route_data.vehicle_info && route_data.vehicle_info.length">
        <div class="text-left bordered rounded p-2">
          <div class="title rounded bg-grey-lighter py-5 px-5 w-full text-center flex items-center justify-between gap-10p">
            <div class="head_item">Vehicle name</div>
            <div class="head_item">Reg. number</div>
            <div class="head_item">Make</div>
            <div class="head_item">Type</div>
            <div class="head_item">Height</div>
            <div class="head_item">Width</div>
            <div class="head_item">Length</div>
            <div class="head_item">Weight</div>
          </div>
          <div class="vehicles">
            <div class="items py-5 px-5 text-center flex items-center justify-between gap-10p" v-for="(veh, i) in route_data.vehicle_info" :key="i">
              <span class="item">{{veh.name || '-'}}</span>
              <span class="item">{{veh.registration_number || '-'}}</span>
              <span class="item">{{veh.vehicle_make || '-'}}</span>
              <span class="item text-120px">
                {{ veh.vehicle_type ? parseTypeByKeys(veh.vehicle_type) : '-' }}
              </span>
              <span class="item">{{veh.height || '-'}} m</span>
              <span class="item">{{veh.width || '-'}} m</span>
              <span class="item">{{veh.length || '-'}} m</span>
              <span class="item">{{veh.weight || '-'}} t</span>
            </div>
          </div>
        </div>
      </div>

      <div class="trailers_details px-16 py-5" v-if="route_data.trailer_info && route_data.trailer_info.length">
        <div class="text-left bordered rounded p-2">
          <div class="title rounded bg-grey-lighter py-5 px-5 w-full text-center flex items-center justify-between gap-10p">
            <div class="head_item">Trailer name</div>
            <div class="head_item">Trailer id</div>
            <div class="head_item">Height</div>
            <div class="head_item">Width</div>
            <div class="head_item">Length</div>
          </div>
          <div class="trailers">
            <div class="items py-5 px-5 flex items-center justify-between gap-10p" v-for="(veh, i) in route_data.trailer_info" :key="i">
              <span class="item">{{veh.name || '-'}}</span>
              <span class="item">{{veh.trailer_id || '-'}}</span>
              <span class="item">{{veh.height || '-'}} m</span>
              <span class="item">{{veh.width || '-'}} m</span>
              <span class="item">{{veh.length || '-'}} m</span>
            </div>
          </div>
        </div>
      </div>

      <div class='reach_text px-16' v-if='react_text'>
        <div class=' py-5' v-html='react_text'></div>
      </div>

      <div class="route-overview px-16 py-6 w-full flex items-start gap-15">
        <div class="route-overview-direction w-3/12">
          <div class="inner way" v-if="route_data.direction_data.routes[0].sections">
            <div class="flex-none p-4 border-b">
              <div class="flex justify-between items-center">
                <strong class="text-xl font-medium">
                  Directions
                </strong>
              </div>
              <div class="justify-between font-medium">
                <div class="block text-lg text-orange-dark">
                  {{ fullTime() }}
                  <span class="text-lg text-grey-dark">{{ parsedDistance.m }} miles ({{ parsedDistance.k }} km)</span>
                </div>
                <div class="block text-lg text-orange-dark" v-if='is_paused'>
                  Driving time: {{ drivingTime() }}
                </div>
                <div class="text-xs pt-1 text-grey-dark">
<!--                  Vehicle Dimensions:-->
<!--                  H:{{ getVehiclesDimensions.height.val }}m-->
<!--                  W:{{ getVehiclesDimensions.width.val }}m-->
<!--                  L:{{ getVehiclesDimensions.length.val }}m-->
<!--                  Wt:{{ getVehiclesDimensions.weight.val }}t-->
                </div>
              </div>
            </div>
            <RouteInstructions
              v-if="route_data.direction_data.routes[0].sections"
              :sections="route_data.direction_data.routes[0].sections"
            />
          </div>
        </div>

        <div
          class="route-overview-map bordered rounded overflow-hidden"
          :class="hasDrivenHistory ? 'w-8/12' : 'w-9/12'"
        >
          <MapRouteLegend :items="mapLegendItems" />
          <HereMap
            v-if="route_data.direction_data"
            :routeData="unifiedMapData"
            :is_plan="false"
            :map_width="'100%'"
            :map_height="'580px'"
            :zoom_default="6"
            :routeVersionMode="!!selectedDrivenVersion"
            :plannedBaseOverlay="!!selectedDrivenVersion"
            :selectedVersionIndex="1"
          />
        </div>

        <div
          v-if="hasDrivenHistory"
          class="route-overview-history w-1/12"
        >
          <h3 class="text-sm font-medium mb-1">Driven route history</h3>
          <button
            v-for="entry in historyEntries"
            :key="'history-' + entry.trip_id"
            type="button"
            class="history-row w-full text-left py-2 px-2 border rounded mb-1"
            :class="{
              'history-row-active':
                selectedDrivenVersion &&
                selectedDrivenVersion.route_log_id === entry.route_log_id,
            }"
            @click="selectHistoryEntry(entry)"
          >
            <div class="text-xs">{{ entry.created_at | moment('DD-MM-YYYY HH:mm') }}</div>
            <div class="text-xs text-grey-dark">
              <span v-if="entry.leg_id">Leg {{ entry.leg_id }} · </span>{{ entry.driver_name || '-' }}
            </div>
          </button>
        </div>
      </div>
    </div>

    <ShareRoutes
      v-if="getShowShareRoutes && shareOneRoute"
      :ids="shareItem"
    />
    <DeleteModal
      :entity="'route'"
      v-on:delete-select="confirmDelete"
      v-on:delete-close="closeDelete"
      ref="delete_modal"
    />
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import moment from "moment";
import {createIconWithText, parseTypeByKeys, secondsToDhms} from "@/services/helpers";
import RouteInstructions from "@/components/plan-elements/RouteInstructions.vue";
import HereMap from "@/components/HereMap.vue";
import MapRouteLegend from "@/components/MapRouteLegend.vue";
import ShareRoutes from "@/components/ShareRoutes.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import {baseErrHandler, getUserRoutesText} from "@/services/api";
import {infoMessage} from "@/services/messages";
import {
  DRIVEN_ROUTE_STROKE,
  OVERLAY_ROUTE_LINE_WIDTH,
  PLANNED_ROUTE_LINE_WIDTH,
  ROUTE_SECTION_COLORS,
} from "@/constants/route-map-overlay";

export default {
  name: "Route",
  components: {
    HereMap,
    MapRouteLegend,
    RouteInstructions,
    ShareRoutes,
    DeleteModal,
  },
  data() {
    return {
      is_paused: false,
      route_data: [],
      react_text: '',
      user_data: JSON.parse(localStorage.getItem('user')),
      shareItem: [],
      shareOneRoute: true,
      colors: {
        0: 'blue',
        1: 'red',
        2: 'green',
        3: 'yellow',
        4: 'blue',
        5: 'red',
        6: 'green',
        7: 'yellow',
        8: 'blue',
        9: 'red'
      },
      timeDuration: 0,
      distance: 0,
      parsedDistance: {
        k: null,
        m: null
      },
      waypoints: [],
      partDistance: [],
      traffic_main: null,
      add_vehicles: null,
      low_emission: null,
      ulez: null,
      london_control: null,
      error_load: false,
      loaded_info: false,
      driven_history: {
        trips: [],
      },
      selectedDrivenVersion: null,
    }
  },
  computed: {
    ...mapGetters([
      'getMultiWaypointsText',
      'getColors',
      'getMarkers',
      'getMultiWaypoints',
      'getShowShareRoutes'
    ]),
    originLabel() {
      if (!this.route_data?.route_info) {
        return '-';
      }
      const loc = this.route_data.route_info.locations?.[0]?.geo;
      if (loc?.postcode || loc?.region) {
        const parts = [loc.postcode, loc.region].filter(Boolean);
        return parts.join(', ') || '-';
      }
      const sections =
        this.route_data.direction_data?.routes?.[0]?.sections;
      const place = sections?.[0]?.departure?.place;
      if (place) {
        const parts = [place.postalCode, place.address].filter(Boolean);
        return parts.join(', ') || '-';
      }
      const startName = this.route_data.route_info.locations_names?.start;
      return startName && String(startName).trim() ? startName : '-';
    },
    hasDrivenHistory() {
      return !!(this.driven_history.trips && this.driven_history.trips.length);
    },
    historyEntries() {
      if (!this.driven_history.trips || !this.driven_history.trips.length) {
        return [];
      }

      return this.driven_history.trips
        .map((trip) => {
          const activeVersion = this.getActiveTripVersion(trip);
          if (!activeVersion) {
            return null;
          }

          return {
            ...activeVersion,
            trip_id: trip.trip_id,
            created_at: trip.created_at,
            driver_name: trip.driver_name,
          };
        })
        .filter(Boolean);
    },
    unifiedMapData() {
      if (!this.route_data || !this.route_data.direction_data) {
        return null;
      }

      if (
        !this.selectedDrivenVersion ||
        !this.selectedDrivenVersion.map_data
      ) {
        return this.route_data.direction_data;
      }

      const plannedRoute = this.route_data.direction_data.routes[0];
      const drivenRoute =
        this.selectedDrivenVersion.map_data.routes &&
        this.selectedDrivenVersion.map_data.routes[0];

      if (!plannedRoute || !drivenRoute) {
        return this.route_data.direction_data;
      }

      return {
        routes: [plannedRoute, drivenRoute],
      };
    },
    mapLegendItems() {
      const plannedSections =
        this.route_data &&
        this.route_data.direction_data &&
        this.route_data.direction_data.routes &&
        this.route_data.direction_data.routes[0] &&
        this.route_data.direction_data.routes[0].sections;

      if (!plannedSections || !plannedSections.length) {
        return [];
      }

      const items = plannedSections.map((unusedSection, index) => ({
        label: `Route leg ${index + 1}`,
        color: ROUTE_SECTION_COLORS[index % ROUTE_SECTION_COLORS.length],
        lineWidth: PLANNED_ROUTE_LINE_WIDTH,
      }));

      if (
        this.selectedDrivenVersion &&
        this.selectedDrivenVersion.map_data &&
        this.selectedDrivenVersion.map_data.routes &&
        this.selectedDrivenVersion.map_data.routes[0] &&
        this.selectedDrivenVersion.map_data.routes[0].sections &&
        this.selectedDrivenVersion.map_data.routes[0].sections.length
      ) {
        items.push({
          label: 'Driven route',
          color: DRIVEN_ROUTE_STROKE,
          lineWidth: OVERLAY_ROUTE_LINE_WIDTH,
        });
      }

      return items;
    },
  },
  methods: {
    secondsToDhms,
    parseTypeByKeys,
    createIconWithText,
    ...mapMutations([
      'setMultiWaypointsText',
      'setMarkers',
      'setMultiWaypoints',
      'setLoading',
      'setShowShareRoutes'
    ]),
    async printPage() {
      if (this.route_data.route_version === 'v2') {
        return await this.$router.push({name: "RoutePrintV2", params: {id: this.$route.params.id}});
      }
      await this.$router.push({path: '/routes/' + this.$route.params.id + '/print'})
    },
    goBack() {
      this.$router.go(-1);
    },
    getDateTime(dtime) {
      const formattedDate = dtime.replace(/T(\d{2}:\d{2}):.*$/, ' $1');
      return moment(formattedDate).format('DD-MM-YYYY, HH:mm');
    },
    estimatedEndTime(dtime) {
      return moment(dtime).add(this.timeDuration, 'seconds').format('DD-MM-YYYY, HH:mm');
    },
    formatPlannedExpectedDuration() {
      if (!this.route_data) {
        return '-';
      }
      var start = null;
      var end = null;
      var sections =
        this.route_data.direction_data &&
        this.route_data.direction_data.routes &&
        this.route_data.direction_data.routes[0] &&
        this.route_data.direction_data.routes[0].sections;
      if (sections && sections.length) {
        var firstSection = sections[0];
        var lastSection = sections[sections.length - 1];
        if (
          firstSection.departure &&
          firstSection.departure.time
        ) {
          start = firstSection.departure.time;
        }
        if (lastSection.arrival && lastSection.arrival.time) {
          end = lastSection.arrival.time;
        }
      }
      if ((!start || !end) && this.route_data.route_info) {
        start = start || this.route_data.route_info.time_start;
        end = end || this.route_data.route_info.time_end;
      }
      if (!start || !end) {
        return '-';
      }
      var diffSeconds = moment(end).diff(moment(start), 'seconds');
      if (diffSeconds <= 0) {
        return '-';
      }
      return this.secondsToDhms(diffSeconds);
    },
    async loadDrivenHistory() {
      try {
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/routes/${this.$route.params.id}/driven-history`,
        );
        this.driven_history = response.data || { trips: [] };
        if (this.driven_history.trips.length) {
          this.selectedDrivenVersion =
            this.getActiveTripVersion(this.driven_history.trips[0]) || null;
        }
      } catch (e) {
        this.driven_history = { trips: [] };
      }
    },

    getActiveTripVersion(trip) {
      if (!trip || !trip.versions || !trip.versions.length) {
        return null;
      }

      return (
        trip.versions.find((version) => version.is_active) ||
        trip.versions[trip.versions.length - 1]
      );
    },

    selectHistoryEntry(entry) {
      this.selectedDrivenVersion = entry;
    },

    async getRoute() {
      this.setLoading(true);
      try {
        const route = await this.$http.getAuth(`${this.$http.apiUrl()}/routes/${this.$route.params.id}`) || [];
        this.route_data = route.data;
        if (!this.route_data) {
          this.setLoading(false);
          this.error_load = true;
          return;
        }
        await this.parseDistance();
        await this.loadDrivenHistory();
      } catch (e) {
        console.log(e);
        this.error_load = true;
        this.setLoading(false);
      }
      this.error_load = false;
      this.loaded_info = true;
      this.setLoading(false);
    },
    fullTime() {
      const seconds = this.route_data.direction_data.routes[0].sections.reduce((acc, section) => {
        if (section.postActions && section.postActions.length > 0) {
          this.is_paused = true;
          section.postActions.forEach((action) => {
            if (action.action === 'wait') {
              acc += action.duration;
            }
          });
        }
        return acc + section.travelSummary.duration;
      }, 0);
      return secondsToDhms(seconds)
    },

    drivingTime() {
      const seconds = this.route_data.direction_data.routes[0].sections.reduce((acc, section) => {
        return acc + section.travelSummary.duration;
      }, 0);
      return secondsToDhms(seconds)
    },
    sectionWaitDuration(section) {
      if (!section || !section.postActions || !section.postActions.length) return 0;
      return section.postActions
        .filter(a => a && a.action === 'wait' && typeof a.duration === 'number')
        .reduce((sum, a) => sum + a.duration, 0);
    },

    async parseDistance() {
      const sections =
        this.route_data?.direction_data?.routes?.[0]?.sections;
      if (!sections?.length) {
        return;
      }
      const travelLength = sections.reduce((acc, section) => {
        return acc + (section.travelSummary?.length ?? 0);
      }, 0);
      this.parsedDistance.k = Math.round(travelLength / 1000);
      this.parsedDistance.m = Math.round((travelLength / 1000) / 1.609344);
    },

    distanceToString(meters) {
      if(meters)
        return `${Math.round(meters / 1000)} Km (${Math.round((meters / 1000) / 1.609344)} miles)`;
      else return ''
    },

    async getRoutesText() {
      await baseErrHandler(async () => {
        const user = await getUserRoutesText();
        this.react_text = user?.data?.user?.routes_info;
      });
    },

    deleteRoute() {
      this.$refs.delete_modal.show = true;
    },

    closeDelete() {
      this.$refs.delete_modal.show = false;
    },

    async confirmDelete() {
      try {
        await this.$http.deleteAuth(`${this.$http.apiUrl()}/routes/${this.$route.params.id}`);
        infoMessage(
          'Route deleted successfully',
          'success'
        );
        // Redirect to routes list
        this.$router.push({name: 'Routes'});
      } catch (e) {
        console.log(e);
        infoMessage(
          'Oops. Something went wrong...',
          'error'
        );
      }
    },

    rePlanRoute() {
      this.$router.push({name: 'HereRePlan', query: {replan_route_id: this.$route.params.id}});
    },

    shareRoute() {
      this.shareItem = [];
      this.shareItem.push(this.$route.params.id);
      this.shareOneRoute = true;
      this.setShowShareRoutes(true);
    },
  },
  async mounted() {
    await this.getRoute();
    await this.getRoutesText();
  },
}
</script>

<style lang="scss" scoped>
.history-row {
  background: #fff;
  cursor: pointer;

  &:hover {
    background: #f8f9fa;
  }
}

.history-row-active {
  border-color: #007bff;
  background: #f8fbff;
}

.route-overview-direction {
  min-width: 0;

  .inner {
    max-height: 580px;
    height: 580px;
    overflow-y: scroll;
  }
}

.route-overview-map {
  position: relative;
  min-width: 0;
  max-height: 580px;
  height: 580px;
}

.route-overview-history {
  min-width: 0;
  max-height: 580px;
  overflow-y: auto;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.title {
  .head_item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    text-align: left;
  }
}
.vehicles {
  .items {
    .item {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 0;
      text-align: left;
    }
  }
}
.trailers {
  .items {
    .item {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 0;
      text-align: left;
    }
  }
}
</style>
